"use client";
import Image from "next/image";
import Link from "next/link";


const links = [
  "Corporate",
  "Agency",
  "Creative",
  "Design",
  "Minimal",
  "Company",
  "Development",
  "App Landing",
  "Startup",
  "App",
  "Business",
  "Software",
  "Landing",
  "Art",
];
export default function BlogDetails({ blog }: any) {
  return (
    <div className="rainbow-blog-details-area">
      <div className="post-page-banner rainbow-section-gapTop">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="content text-center">
                <div className="page-title">
                  <h1 className="theme-gradient">{blog.title}</h1>
                </div>
                <ul className="rainbow-meta-list">
                  <li>
                    <i className="feather-user" /> <a href="#">Irin Pervin</a>
                  </li>
                  {blog.date && (
                    <li>
                      <i className="feather-calendar" /> {blog.date}
                    </li>
                  )}
                </ul>
                {blog.image && (
                  <div className="thumbnail alignwide mt--60">
                    <Image
                      className="w-100 radius"
                      alt="Blog Images"
                      src={blog.image}
                      width={390}
                      height={240}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blog-details-content pt--60 rainbow-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="content">
                {blog.description}

                <div className="category-meta">
                  <span className="text">Tags:</span>
                  <div className="tagcloud">
                    {links.map((link, index) => (
                      <Link href={`/blog-grid/tag/${link}`} key={index}>
                        {link}
                      </Link>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
